import { render } from "./anchor.vue?vue&type=template&id=480a4684"
import script from "./anchor.vue?vue&type=script&lang=js"
export * from "./anchor.vue?vue&type=script&lang=js"

import "./anchor.vue?vue&type=style&index=0&id=480a4684&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-sold-detail/_components/anchor.vue'],['render',render],['__file',"anchor.vue"]])

export default __exports__